import baseapi from "./../baseAPI";

export const LogDataAPI = async (setLogs, setLoading) =>
{
    setLoading(true);

    try
    {
        const response = await baseapi.get("/api/caller/activity-logs");

        //console.log("Data got successfully", response);
        //let userdata = ['ram', 'shyam', 'rohit'];
        setLogs(response.data.data);
        setLoading(false);
    }
    catch(error) 
    {
        console.error("Error in user list:", error);
        setLoading(false);
    };
}


